import { memo, useMemo } from 'react';

import ReactMarkdown from 'react-markdown';
import type { PluggableList } from 'react-markdown/lib';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeExternalLinks from 'rehype-external-links';

type Props = {
    value: string;
    linkTarget?: string;
    noP?: boolean;
    className?: string;
}

const REMARK_PLUGINS = [remarkGfm, remarkBreaks];

const DISALLOW_P = ['p'];
const SimpleMd = ({ value, linkTarget, noP, className }: Props) => {

    const rehypePlugins: PluggableList = useMemo(() => {
        return [[rehypeExternalLinks, { target: linkTarget }]];
    }, [linkTarget]);

    return (
        <ReactMarkdown
            children={value}
            className={className}
            remarkPlugins={REMARK_PLUGINS}
            rehypePlugins={rehypePlugins}
            disallowedElements={noP ? DISALLOW_P : undefined}
            unwrapDisallowed
        />
    );

};

export default memo(SimpleMd);
